
import Vue from 'vue'
import { RecipientAddressType } from '@/types'
import RadioButton from '@/common/components/RadioButton.vue'
export default Vue.extend({
  name: 'AddressList',
  components: {
    RadioButton
  },
  props: {
    addressList: {
      type: Array as () => RecipientAddressType[],
      required: true
    },
    selectedAddressId: {
      type: Number as  () => number | undefined,
      required: true
    }
  },
  methods: {
    onAddressChange(id: number | undefined, fullAddress: string) {
      if (id === this.selectedAddressId) return
      this.$emit('onAddressChange', id, fullAddress)
    }
  }
})
